import type React from 'react';

import { useLocation } from '@xing-com/crate-core-router';
import { SeoBreadcrumb } from '@xing-com/seo-breadcrumb';

import { useBreadCrumbsConfig } from './routes';

export const CareerHubBreadCrumb: React.FC = () => {
  const { pathname } = useLocation();
  const currentUrl = pathname.replace(/^\/|\/$/g, '');
  const breadCrumbs = useBreadCrumbsConfig();

  const breadCrumbsConfig = breadCrumbs[currentUrl];

  if (!breadCrumbsConfig) {
    return null;
  }

  return <SeoBreadcrumb items={breadCrumbsConfig} />;
};
